// Base error interface
export interface ApiError {
  message: string;
  code?: string;
  details?: unknown;
  status?: number;
}

// Supabase-specific error
export interface SupabaseError {
  message: string;
  details?: string;
  hint?: string;
  code?: string;
}

// Form validation error
export interface ValidationError {
  field: string;
  message: string;
}

// Type guard for API errors
export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as ApiError).message === 'string'
  );
}

// Type guard for Supabase errors
export function isSupabaseError(error: unknown): error is SupabaseError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as SupabaseError).message === 'string'
  );
}

// Safe error message extraction
export function getErrorMessage(error: unknown): string {
  if (isApiError(error) || isSupabaseError(error)) {
    return error.message;
  }
  
  if (error instanceof Error) {
    return error.message;
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  return 'An unexpected error occurred';
}

// Error handler type for async functions
export type ErrorHandler = (error: unknown) => void | Promise<void>;